export default __webpack_public_path__ + "static/media/KOD0098-min.4f380ca4.webp";